<template>
  <div>
    <section class="content displayJob">
      <div ref="exportBigQuryPopup" class="exportBigQuryPopupWrapper">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modelpopContainer exportBigQuryPopup">
              <a class="close-btn" @click="closeexportBigQuryPopup()">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
              <div class="clearfix">
                <div class="stepsheading expotbgheading">Export to Bigquery</div>
              </div>
              <div class="exportBqCheckbox clearfix">
                <div class="expotbgjobname">Job Name: {{currentExportName}}</div>
                <div class="error">{{bgQcheckerrormsg}}</div>
                <div class="checkbox">
                  <input
                    id="selall"
                    value="123"
                    type="checkbox"
                    v-on:change="exporttypeBqselctedAll()"
                    :checked="selectallbqtype ? 'checked' : ''"
                  >
                  <label for="selall">Select All</label>
                </div>
                <div
                  ref="exportbgCompo"
                  class="checkbox"
                  v-for="(exporttypeBq) in exporttypeBq"
                  v-bind:key="exporttypeBq.id"
                >
                  <input
                    v-bind:checked="exporttypeBq.checked"
                    type="checkbox"
                    v-bind:ref="exporttypeBq.ref"
                    v-bind:id="exporttypeBq.ref"
                    class
                    v-bind:value="exporttypeBq.id"
                    @change="exporttypeBqselcted(exporttypeBq.id, exporttypeBq.checked)"
                    v-model="exporttypeBq.checked"
                  >
                  <label v-bind:for="exporttypeBq.ref">{{exporttypeBq.name}}</label>
                </div>
              </div>
              <div class="btnexporttobigqwrapper">
                <button
                  class="btn btn-primary btn-large"
                  @click="exporttobigqClick()"
                  rel="btnexporttobigq"
                >Export</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="shareamodel" class="ShareModelPopupWrapper">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modelpopContainer exportBigQuryPopup">
              <a class="close-btn" @click="closeShareModel()">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
              <div class="clearfix">
                <div class="stepsheading expotbgheading">Share a Model</div>
              </div>
              <div class="exportBqCheckbox clearfix">
                <div class="sharejobid">Job ID: {{currentShareJob}}</div>
                <div class="error">{{bgQcheckerrormsg}}</div>
                <div class="shareselectbtn">
                  <button
                    ref="selallforshare"
                    value="all"
                    class="btn btn-primary btn-small"
                    @click="shareAllusers(shareselectAll)"
                  >{{shareselecttxt}}</button>
                </div>
                <div
                  ref="sharejobref"
                  class="checkbox"
                  v-for="(shareJob, index) in shareJob"
                  v-bind:key="shareJob.user_id"
                  v-if="shareJob.user_id !== currentuser"
                >
                  <input
                    v-bind:checked="shareJob.shared === 1 ? 'checked' : ''"
                    type="checkbox"
                    v-bind:id="shareJob.user_id"
                    v-bind:value="shareJob.user_id"
                    v-model="selectedshareJobType"
                    @change="selectedshareJob(index, selectedshareJobType)"
                  >
                  <label v-bind:for="shareJob.user_id">{{shareJob.fullname}}</label>
                </div>
              </div>
              <div class="btnexporttobigqwrapper">
                <button
                  class="btn btn-primary btn-large"
                  @click="ShareJobClick()"
                  rel="ShareJobClick"
                >Share</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Createjob
        ref="jobcompo"
        :showmodelprop="showmodelin"
        :copymodel="CopyModelBool"
        :copyData="CopiedData"
      >Test</Createjob>
      <vue-good-table
        ref="jobtable"
        :selectOptions="selectionOptions"
        @on-row-click="onPageChange"
        @on-select-all="onPageChangeSelectALL"
        @on-selected-rows-change="selectionChanged"
        @on-cell-click="onCellClick"
        @on-sort-change="onSortChange"
        mode="local"
        :isLoading="isLoadingcompo"
        styleClass="table table-bordered condensed"
        :columns="columns"
        :rows="RowFilter"
        :paginate="true"
        :lineNumbers="true"
        :perPage="22"
        :sortable="true"
        :globalSearch="false"
        name="test"
        :sort-options="{enabled: false}"
      >
        <template slot="loadingContent">
          <span class="vgt-loading__content">
            <div class="dataspinner">
              <span>Loading Data</span>
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </span>
        </template>
        <div slot="selected-row-actions">
          <button
            class="btn btn-large btn-primary btn-red deleteAllbtn"
            @click="removeMultiSelectedJobAlert()"
          >
            <i class="fa fa-trash"></i>
          </button>
          <button class="btn btn-btnbigquerry" @click="exportMultiSelectedJobAlert()">
            <i class="btnbigquerry btnbigquerry-over"></i>
          </button>
        </div>
        <template slot="table-row" slot-scope="props">
          <div class="td-wrapper">
            <div class="viewrepottbuttonwrapper" v-if="props.column.field == 'name'">
              <a
                class="viewmodellink"
                href="javascript:"
                @click="viewreportbuttonClick(props.row)"
              >{{props.formattedRow[props.column.field]}}</a>
            </div>
            <div class="settingswrapper" v-if="props.column.field == 'name'">
              <button
                tabindex="-1"
                class="btn btn-primary view-btn settingsBtn"
                @click="openSetting(props, props.row, $event)"
                type="button"
              >
                <svg width="20" height="20" viewBox="0 -3 35 35" fill="#ffffff">
                  <g transform="scale(0.03125 0.03125)">
                    <path
                      d="M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
                    ></path>
                  </g>
                </svg>
              </button>
              <div class="settingPopup" ref="settingPopup">
                <a class="closebtn" @click="settingPopupClose(props, props.row, $event)">
                  <i aria-hidden="true" class="fa fa-times"></i>
                </a>
                <button
                  class="btn btn-sm btn-primary view-btn settingsBtn btnShareJob"
                  @click="CopyModel(props.row)"
                >
                  <i class="fa fa-files-o"></i>
                </button>
                <button
                  tabindex="-1"
                  class="btn btn-sm settingsDel btn-primary view-btn settingsBtn btn-red"
                  @click="removeSelectedJobAlert(props.row, $event)"
                  type="button"
                >
                  <i class="fa fa-trash"></i>
                </button>
                <button class="btn btnbigquerry btn-sm" @click="openexportbgPopuop (props.row)"></button>
                <button
                  class="btn btn-sm btn-primary view-btn settingsBtn btnShareJob"
                  @click="openShareJobPopuop (props.row)"
                >
                  <i class="fa fa-share-alt"></i>
                </button>
              </div>
            </div>
            <div class="statusLoader" v-if="props.column.field == 'status'">
              <i
                v-if="props.formattedRow[props.column.field] === 'created'"
                class="fa fa-check-circle yellow"
                aria-hidden="true"
              ></i>
              <i
                v-if="props.formattedRow[props.column.field] === 'completed'"
                class="fa fa-check-circle green"
                aria-hidden="true"
              ></i>
              <i
                v-if="props.formattedRow[props.column.field] === 'in-progress'"
                class="fa fa-spinner green"
                aria-hidden="true"
              ></i>
              <i
                v-if="props.formattedRow[props.column.field] === 'failed'"
                class="fa fa-exclamation-circle red"
                aria-hidden="true"
              ></i>
              <div class="statusLoaderover">{{props.formattedRow[props.column.field]}}</div>
            </div>
            <span
              v-else-if="props.column.field !== 'name'"
            >{{props.formattedRow[props.column.field]}}</span>
          </div>
        </template>
      </vue-good-table>
    </section>
  </div>
</template>

<script>
/*eslint-disable */
import $ from 'jquery'
var jQuery = $
// Require needed datatables modules
import VueGoodTable from '../../../node_modules/vue-good-table/src/components/Table.vue'
import 'vue-good-table/dist/vue-good-table.css'
import Createjob from './Createjob.vue'
var loaddata = []
export default {
  name: 'Tables',
  components: {
    VueGoodTable,
    Createjob,
  },
  data () {
    return {
      CopiedData: [],
      CopyModelBool: false,
      RowFilter: [],
      CurrentActiveJobID: '',
      CurrentActiveUniqueID: '',
      Pongstyles: {},
      selectedMultiJobID: [],
      selectedMultiJob_UID: [],
      exporttypeBq: [
        {
          name: 'Consumer Journey',
          id: '1',
          ref: 'ebginput1',
          checked: '',
        },
        {
          name: 'Weekly Consumer Journey',
          id: '2',
          ref: 'ebginput2',
          checked: '',
        },
        // { name: 'Model Weights', id: '3', ref: 'ebginput3', checked: '' }
      ],
      shareJobtypeBq: [],
      shareselectAll: true,
      shareselecttxt: 'Select All Users',
      isLoadingcompo: true,
      selectallbqtype: false,
      bgQcheckerrormsg: '',
      selectedBqType: [],
      selectallSharetype: false,
      shareJobcheckerrormsg: '',
      selectedshareJobType: [],
      selectedShareUsers: [],
      currentExportName: '',
      currentExportJob: [],
      currentShareJob: '',
      currentShareJob_uniqueId: '',
      currentuser: '',
      rows: loaddata,
      showmodelin: false,
      tableLoading: true,
      loading: true,
      timer: 2000,
      shareJob: [],
      selectionOptions: {
        enabled: true,
        selectionText: 'Model(s) selected',
        clearSelectionText: 'clear',
        selectOnCheckboxOnly: false,
        selectionText: 'rows selected'
      },
      columns: [
        {
          label: 'Name',
          field: 'name',
          type: 'text',
          html: false,
          filterable: false,
          sortable: true,
          width: '390px',
        },
        {
          label: 'Job ID',
          field: 'id',
          type: 'text',
          html: false,
          filterable: false,
          sortable: true,
          width: '200px',
        },
        {
          label: 'Client',
          field: 'client',
          html: true,
          filterable: false,
          sortable: true,
          width: '100px',
        },
        {
          label: 'Market',
          field: 'selectedMarket',
          type: 'text',
          html: false,
          sortable: true,
          filterable: false,
        },
        {
          label: 'Kpi',
          field: 'selectedKpi',
          type: 'text',
          html: false,
          sortable: true,
          filterable: false,
        },
        {
          label: 'Status',
          field: 'status',
          type: 'html',
          html: true,
          sortable: true,
          tdClass: 'status',
          thClass: 'status',
          filterDropdown: true,
          filterOptions: ['completed', 'created'],
          width: '120px',
        },
        {
          label: 'Created Date',
          field: 'last_modified',
          html: false,
          sortable: true,
          filterable: true,
          thClass: 'add-sorting-icon',
          width: '150px',
        },
        {
          label: 'Created By',
          field: 'created_by',
          html: false,
          sortable: true,
          filterable: true,
          width: '150px',
        },
        {
          label: 'Start Date',
          field: 'start_date',
          type: 'text',
          html: false,
          sortable: true,
          filterable: false,
          width: '100px',
        },
        {
          label: 'End Date',
          field: 'end_date',
          html: false,
          sortable: true,
          filterable: false,
          width: '100px',
        },
        {
          label: 'User',
          field: 'user',
          html: false,
          filterable: false,
          hidden: true,
        },
        {
          label: 'unique id',
          field: 'unique_id',
          html: false,
          filterable: false,
          hidden: true,
        },
        // {
        //   label: 'Export to bigquerry',
        //   field: 'bigquerry',
        //   html: true,
        //   width: '160px',
        //   tdClass: 'text-center'
        // }
      ],
    }
  },
  mounted () {
    this.$root.$on('DisplayJob', () => {
      this.filterfilldatatable()
    })
    var self = this
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        self.$Simplert.close()
      }
    })

    this.captureResponce()
    this.loadDatatoTable()
  },
  computed: {
    shareJobsetter: {
      set: function () {
        return this.shareJob
      },
      get: function () {
        return
      },
    },
  },
  watch: {
    CurrentActiveJobID: function (newval, oldval) {
      window.localStorage.setItem('jobid', newval)
      return newval
    },
    CurrentActiveUniqueID: function (newval, oldval) {
      window.localStorage.setItem('unique_id', newval)
      return newval
    },
    RowFilter: function (o, n) {
      this.FillRowFilter()
      this.rows.filter(function (a) {
        console.log(a)
      })
      // this.$refs.jobtable.resetTable()
      return this.rows
    },
  },
  created: function () {
    this.captureResponce()
    $('.viewrepottbuttonwrapper').on('load', function (e) {
      console.log(e)
    })
  },
  methods: {
    CopyModel (rdata) {
      var self = this
      let copypapams = rdata
      let user = window.localStorage.getItem('user')
      var postdata = JSON.stringify({ 'user_id': user, 'unique_id': rdata.unique_id })
      self.$pingpong.displayLoader()
      var promiseObj = new Promise(function (resolve, reject) {
        $.ajax({
          type: 'POST',
          url: window.localStorage.getItem('ApiURL') + '/GetModelConfig',
          data: postdata,
          async: true,
          contentType: 'application/json',
          headers: {
            'x-api-key': window.localStorage.getItem('XpiKey'),
          },

          success: function (data, textStatus, jqXHR) {
            console.log(data, textStatus, jqXHR)
            if (data.length === 0) {
              return '';
            }
            self.CopyModelBool = true
            // let channel_grouping_url = data.channel_grouping_url
            data = JSON.parse(data.output)
            // data.push(channel_grouping_url)
            self.CopiedData = data
            console.log(data)
            self.$refs.jobcompo.modelpopupbuttonClick(data, 'copy')
            resolve(data)
            self.$pingpong.hideloader()
            // self.$refs.jobcompo.getCdata(data)
          },
          error: function (jqXHR, error, errorThrown) {
            console.log(jqXHR, error, errorThrown)
            reject(errorThrown)
            self.$pingpong.hideloader()
          }
        })
      })
    },
    onCellClick (params) {
      console.log(params)
      // if (this.selectedMultiJobID.includes(params.row.id)) {
      //   this.selectedMultiJobID.splice(params.row.id)
      //   if (params.event.target.parentElement.parentNode.parentNode.classList.contains('clickable')) {
      //     params.event.target.parentElement.parentElement.parentElement.classList.remove('checked')
      //   }
      //   if (params.event.target.parentElement.parentNode.parentNode.childNodes[2].classList.contains('checked')) {
      //     params.event.target.parentElement.parentNode.parentNode.childNodes[2].classList.remove('checked')
      //   }
      //   if ((params.event.target.parentElement.parentElement.classList.contains('checked'))) {
      //     params.event.target.parentElement.parentElement.classList.remove('checked')
      //   }
      //   if ((params.event.target.parentElement.classList.contains('checked'))) {
      //     params.event.target.parentElement.classList.remove('checked')
      //   }
      //   if ((params.event.target.classList.contains('checked'))) {
      //     params.event.target.classList.remove('checked')
      //   }
      // }
    },
    selectionChanged (params) {
      if (params.selectedRows.length === 0) {
        $('.clickable').removeClass('checked')
      }
      console.log(params)
      // index of page
      console.log(params.pageIndex)
      // whether the row was selected or unselected
      console.log(params.selected)
    },
    loadDatatoTable () {
      var self = this
      var userchk = window.localStorage.getItem('user')
      if (
        this.$route.query.showmodel === 'true' ||
        this.$route.query.showmodel === true
      ) {
        this.$refs.jobcompo.modelpopupbuttonClick()
        return
      }
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/JobStatusCheck',
        data: { user: userchk },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // $('.dataspinner').show()
          self.isLoadingcompo = false
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.displaypopuperr()
          }
          data = JSON.parse(data['job_status_data'])
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          console.log(data)
          self.rows = data
          self.filterfilldatatable()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        },
      })
    },
    filterfilldatatable () {
      var self = this
      self.RowFilter = []
      self.rows.filter(function (a) {
        console.log(a.client)
        if (
          window.localStorage.getItem('client') !== 'All Clients' &&
          window.localStorage.getItem('market') !== 'All Markets'
        ) {
          if (
            a.client === window.localStorage.getItem('client') &&
            a.selectedMarket === window.localStorage.getItem('market')
          ) {
            self.RowFilter.push(a)
          }
        }
        if (
          a.client === window.localStorage.getItem('client') &&
          window.localStorage.getItem('market') === 'All Markets'
        ) {
          if (a.client === window.localStorage.getItem('client')) {
            self.RowFilter.push(a)
          }
        }
        if (
          window.localStorage.getItem('client') === 'All Clients' &&
          window.localStorage.getItem('market') === 'All Markets'
        ) {
          self.RowFilter.push(a)
        }
      })
      self.rows.every(function (e, i) {
        // CurrentActiveJobID
        if (self.rows[i].status.toLowerCase() === 'completed') {
          self.CurrentActiveJobID = self.rows[i].id
          window.localStorage.setItem('jobid', self.CurrentActiveJobID)
          self.CurrentActiveUniqueID = self.rows[i].unique_id
          if (self.CurrentActiveUniqueID) {
            window.localStorage.setItem('unique_id', self.CurrentActiveUniqueID)
          }
          return false
        }
      })
    },
    FillRowFilter () {
      let rowfilter = this.rows
      rowfilter.filter(function (a) {
        console.log(a)
      })
      console.log(rowfilter)
      return rowfilter
    },
    selectedshareJob (index, vtype) {
      if (vtype.includes(this.shareJob[index].user_id)) {
        this.shareJob[index].shared = 1
      } else {
        this.shareJob[index].shared = 0
      }
    },
    shareAllusers (val) {
      var self = this
      var selVal = val
      // let shjon = this.shareJob
      this.shareJob.forEach(function (el, index) {
        if (el.user_id !== self.currentuser) {
          self.shareJob[index].shared = selVal
        }
        if (selVal === true) {
          self.selectedshareJobType.push(el.user_id)
          self.shareselectAll = false
          self.shareselecttxt = 'Remove All Users'
          return
        } else {
          self.selectedshareJobType = []
          self.shareselectAll = true
          self.shareselecttxt = 'Select All Users'
          return
        }
      })
    },
    settingPopupClose (prop, entPointData, objevent) {
      objevent.currentTarget.parentElement.classList.remove('active')
    },
    openSetting (prop, entPointData, objevent) {
      jQuery('.settingPopup').removeClass('active')
      console.log(prop.row.owned)
      console.log(entPointData)
      if (prop.row.owned === false) {
        objevent.currentTarget.nextElementSibling.lastChild.disabled = true
      }
      objevent.currentTarget.nextElementSibling.classList.add('active')
      // $('.model-history .highlitetr').removeClass('highlitetr')
      // this.viewButton = true
      // objevent.currentTarget.parentNode.parentNode.parentElement.classList.add(
      //   'highlitetr',
      // )
    },
    deletetriggerSuccess () {
      let obj = {
        title: 'Report Deleted',
        message: '',
        type: 'success',
        onClose: this.refreshpage(),
        customClass: 'success',
      }
      this.$Simplert.open(obj)
    },
    deleteMultiModelSuccess () {
      let obj = {
        title: 'Delete model job triggered successfully',
        message:
          'You will recive an email upon successfully deletion of your model(s)',
        type: 'success',
        customClass: 'success',
      }
      this.$Simplert.open(obj)
    },
    exportMultiModelSuccess () {
      let obj = {
        title: 'Export to bigquerry job triggered successfully',
        message:
          'You will recive an email upon successfully export of your model(s)',
        type: 'success',
        customClass: 'success',
      }
      this.$Simplert.open(obj)
    },
    refreshpage () {
      window.location.reload()
    },
    deleteOnDemandJob (cudata) {
      console.log(cudata)
      var self = this
      var userchk = window.localStorage.getItem('user')
      var DeljobID = []
      var DeljobUID = []
      DeljobID.push(cudata.id)
      DeljobUID.push(cudata.unique_id)
      var deleteOnDemandJobData = JSON.stringify({
        user_id: userchk,
        job_ids: DeljobID,
        unique_id: DeljobUID,
      })
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerDeleteModel',
        data: deleteOnDemandJobData,
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (data.status === false) {
            self.downloadtriggerFailed(data.message)
            return
          }
          self.deletetriggerSuccess()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.downloadtriggerFailed(data.message)
          // self.displaypopup()
        },
      })
    },
    downloadtriggerFailed (message) {
      let mssg = message
      let obj = {
        title: mssg,
        message: 'Please contact support on Yammer Group',
        type: 'error',
        customClass: 'error',
      }
      this.$Simplert.open(obj)
    },
    removeSelectedJobAlert (propsRow, evt) {
      let self = this
      let currentData = propsRow
      let confirmCloseModal = {
        title: 'Are you sure you want to delete this Report?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          self.deleteOnDemandJob(currentData)
        },
      }
      this.$Simplert.open(confirmCloseModal)
    },
    removeMultiSelectedJobAlert () {
      let self = this
      let currentData = this.selectedMultiJobID.length
      let confirmCloseModal = {
        // eslint-disable-next-line
        title: `Are you sure you want to delete selected ${ currentData } Report(s)?`,
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          self.deleteMultiOnDemandJob()
          // console.log(currentData)
        },
      }
      this.$Simplert.open(confirmCloseModal)
    },
    exportMultiSelectedJobAlert () {
      let self = this
      let currentData = this.selectedMultiJobID.length
      let confirmCloseModal = {
        // eslint-disable-next-line
        title: `Are you sure you want to export all selected jobs to BigQuery ${ currentData }?`,
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          self.exportMultiOnDemandJob()
          // console.log(currentData)
        },
      }
      this.$Simplert.open(confirmCloseModal)
    },
    onPageChange (selected, selectedRows) {
      console.log(selected, selectedRows)
      var selectedMultiJobID = []
      var selectedMultiJob_UID = []
      if (this.$refs.jobtable.selectedPageRows.length === 0) {
        this.selectedMultiJob_UID = []
        if (selected.selected === false) {
          // this.$set(this.$refs.jobtable.rows[selected.pageIndex], 'vgtSelected', false)
          // selected.event.target.setAttribute('checked', 'false')
          // selected.event.target.checked = false
          selected.event.currentTarget.classList.remove('checked')
          if (selected.event.target.parentElement.classList.contains('clickable')) {
            if (selected.event.target.parentNode.parentNode.classList.contains('clickable')) {
              selected.event.target.parentNode.parentNode.classList.remove('checked')
            }
          }
        }
      }
      if (this.$refs.jobtable.selectedPageRows.length > 0) {
        this.$refs.jobtable.selectedPageRows.forEach(function (params, index) {
          selectedMultiJobID.push(params.id)
          selectedMultiJob_UID.push(params.unique_id)
        })
        this.selectedMultiJobID = selectedMultiJobID
        this.selectedMultiJob_UID = selectedMultiJob_UID
        console.log(this.selectedMultiJobID)
        console.log(this.selectedMultiJob_UID)
        // this.$refs.jobtable.rows[pageIndex]
        if (selected.selected === true) {
          selected.event.currentTarget.classList.add('checked')
          // this.$set(this.$refs.jobtable.rows[selected.pageIndex], 'vgtSelected', true)
        } else if (selected.selected === false) {
          selected.event.currentTarget.classList.remove('checked')
          if (selected.event.target.parentElement.classList.contains('clickable')) {
            if (selected.event.target.parentNode.parentNode.classList.contains('clickable')) {
              selected.event.target.parentNode.parentNode.classList.remove('checked')
            }
          }
        }
      }
      // this.isLoadingcompo = false
    },
    onPageChangeSelectALL (selected, selectedRows) {
      if (selected.selectedRows.length === 0) {
        return
      }
      console.log(selected)
      var selectedMultiJobID = []
      var selectedMultiJob_UID = []
      if (selected.selected === true) {
        selected.selectedRows.forEach(function (params, index) {
          selectedMultiJobID.push(params.id)
          selectedMultiJob_UID.push(params.unique_id)
        })
        $('.clickable').addClass('checked')
        this.selectedMultiJobID = selectedMultiJobID
        this.selectedMultiJob_UID = selectedMultiJob_UID
      } else if (selected.selected !== true) {
        $('.clickable').removeClass('checked')
        this.selectedMultiJobID = []
        this.selectedMultiJob_UID = []
      }
    },
    sortFn (params) {
      console.log(params)
      this.isLoadingcompo = false
      this.tableLoading = false
    },
    onSortChange (params) {
      setTimeout(function () {
        // $('th.vgt-left-align').removeClass('add-sorting-icon')
        var elems = document.querySelectorAll(".vgt-left-align.add-sorting-icon");
        [].forEach.call(elems, function (el) {
          el.classList.remove("add-sorting-icon");
        });
      }, 1)
    },
    exporttypeBqselctedAll () {
      var self = this
      if (!this.selectallbqtype) {
        this.exporttypeBq.forEach(function (key) {
          key.checked = 'checked'
          self.selectallbqtype = true
          if (self.selectedBqType.includes(key.id) === false) {
            console.log(key)
            self.selectedBqType.push(key.id)
            self.bgQcheckerrormsg = ''
          }
          return
          // $('.exportBqCheckbox input').attr('checked', 'checked')
        })
      } else if (this.selectallbqtype) {
        this.exporttypeBq.forEach(function (key) {
          key.checked = ''
          self.selectallbqtype = false
          self.selectedBqType = []
          return
          // $('.exportBqCheckbox input').attr('checked', 'checked')
        })
      }
    },
    exporttypeBqselcted (objval, isChecked) {
      console.log(isChecked)
      if (
        this.selectedBqType.includes(objval) === false &&
        isChecked === true
      ) {
        this.selectedBqType.push(objval)
        this.bgQcheckerrormsg = ''
      } else if (
        this.selectedBqType.includes(objval) === true &&
        isChecked === false
      ) {
        this.selectedBqType.splice(this.selectedBqType.indexOf(objval), 1)
      }
    },
    captureResponce () {
      console.log(this.$route.query.showmodel)
      // this.showmodelin = this.$route.query.showmodel
    },
    displaypopupCreated () {
      let obj = {
        title: 'Data Export to BigQuery has been triggered successfully',
        message: '',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displaypopupInprogress () {
      let obj = {
        title: 'Data Export to BigQuery, is already in progress',
        message: '',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displaypopupDone () {
      let obj = {
        title: 'Data already exported to BigQuery',
        message:
          'Data already exported to BigQuery, in case of any issue, Please raise a Yammer message support.',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displaypopupShared () {
      let obj = {
        title: 'Model Shared Successfully',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displaypopupNA () {
      let obj = {
        title: 'Data export for this Job is not possible',
        message: 'In case of any issue, Please raise a Yammer message support.',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displaypopuperr () {
      let obj = {
        title: 'Data Error',
        message: 'Please raise a Yammer message support.',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    displayCreated (e) {
      let obj = {
        title: 'Model is still in-progress, Try Again Later',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose(this),
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
      // if (e.keyCode === 27) {
      //   this.$refs.simplert.closeSimplert(obj)
      // }
    },
    popuponClose (e) {
      // console.log(e)
    },
    displayModelisInProgress: function (status) {
      let inProgressObj = {
        title: 'Model is still in-progress, Try Again Later',
        type: 'warning',
        customClass: 'warning',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      let failedObj = {
        title: 'Model has failed',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      if (status == 'failed') {
        this.$Simplert.open(failedObj)
      } else {
        this.$Simplert.open(inProgressObj)
      }
    },
    viewreportbuttonClick (rowObj) {
      let vsobj = rowObj
      console.log(vsobj)
      if (vsobj.status !== 'completed') {
        this.displayModelisInProgress(vsobj.status)
        return
      } else if (vsobj.status === 'completed') {
        this.CurrentActiveJobID = rowObj.id
        this.CurrentActiveUniqueID = rowObj.unique_id
        window.localStorage.setItem('jobid', this.CurrentActiveJobID)
        window.localStorage.setItem('unique_id', this.CurrentActiveUniqueID)
        window.localStorage.setItem('last_Market', rowObj.selectedMarket)
        window.localStorage.setItem('last_client', rowObj.client)
        window.localStorage.setItem('Job_last_modified', rowObj.last_modified)
        if (rowObj.user !== window.localStorage.getItem('user')) {
          window.localStorage.setItem('job_owner', rowObj.user)
        }
        this.$router.push({
          name: 'DashboardModule',
          params: {
            jid: rowObj.id,
            uid: rowObj.unique_id,
            client: rowObj.client,
            market: rowObj.selectedMarket,
            'Job_last_modified': rowObj.last_modified,
            'job_owner': rowObj.user
          }
        })
      }
    },
    openShareJobPopuop (rowObj) {
      if (rowObj.status == 'completed') {
        var self = this
        let bsobj = rowObj
        this.currentShareJob = bsobj.id
        this.currentShareJob_uniqueId = bsobj.unique_id
        this.$refs.shareamodel.classList.add('active')
        this.currentuser = bsobj.user
        jQuery.ajax({
          type: 'POST',
          url: window.localStorage.getItem('ApiURL') + '/VoyagerGetUsers',
          data: {
            user_id: bsobj.user,
            job_id: bsobj.id,
            unique_id: bsobj.unique_id,
          },
          async: true,
          contentType: 'application/json',
          headers: {
            'x-api-key': window.localStorage.getItem('XpiKey'),
          },
          beforeSend: function () {
            self.$pingpong.displayLoader()
          },
          complete: function () {
            self.$pingpong.hideloader()
          },
          success: function (data) {
            if (
              data.statusCode !== 200 ||
              data.statusCode === undefined ||
              data === undefined
            ) {
              self.displaypopuperr()
            }
            console.log(data.users)
            self.shareJob = data.users
          },
          error: function (data, error) {
            console.log(data)
            console.log(error)
            // self.closeexportBigQuryPopup()
            self.displaypopuperr()
          },
        })
      } else if (rowObj.status == 'in-progress') {
        let obj = {
          title: 'Model is still in-progress, Try Again Later',
          type: 'warning',
          customClass: 'warning',
          onClose: this.popuponClose,
          customCloseBtnText: 'Close',
        }
        this.$Simplert.open(obj)
      } else {
        let obj = {
          title: 'Model has failed',
          type: 'error',
          customClass: 'error',
          onClose: this.popuponClose(this),
          customCloseBtnText: 'Close',
        }
        this.$Simplert.open(obj)
      }
    },

    closeShareModel () {
      this.$refs.shareamodel.classList.remove('active')
      this.shareJob = []
      this.selectedshareJobType = []
      this.shareselectAll = true
      this.shareselecttxt = 'Select All Users'
    },
    openexportbgPopuop (rowObj) {
      let ebsobj = rowObj
      if (ebsobj.status.toLowerCase() !== 'completed') {
        this.displayCreated()
        return
      } else if (ebsobj.status.toLowerCase() === 'completed') {
        this.currentExportName = ebsobj.name
        this.currentExportJob = ebsobj
        this.$refs.exportBigQuryPopup.classList.add('active')
      }
    },
    closeexportBigQuryPopup (rowObj) {
      this.$refs.exportBigQuryPopup.classList.remove('active')
      this.selectedBqType = []
      this.resetBigQform()
    },
    exporttobigqClick () {
      var bsobj = this.currentExportJob
      var selectedBqType = this.selectedBqType
      if (selectedBqType.length === 0) {
        this.bgQcheckerrormsg = 'Please Select a Value'
        return false
      }
      var selectedBqTypeStr = selectedBqType.join('')
      console.log(selectedBqTypeStr)
      var self = this
      if (bsobj.status !== 'completed') {
        self.displayCreated()
        return
      }
      let uidarr = []
      uidarr.push(bsobj.unique_id)
      var exportpostdata = {
        'user_id': bsobj.user,
        'job-id': bsobj.id,
        client: bsobj.client,
        exportType: selectedBqTypeStr,
        unique_id: uidarr,
      }
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/ExportJobsHandler',
        data: JSON.stringify(exportpostdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.displaypopuperr()
          }
          console.log(data)
          let statusD = data['export-status']
          self.closeexportBigQuryPopup()
          if (statusD === 'created') {
            self.displaypopupCreated()
            // s
          } else if (statusD === 'in-progress') {
            self.displaypopupInprogress()
            //
          } else if (statusD === 'not-applicable') {
            self.displaypopupNA()
            //
          } else {
            self.displaypopupDone()
          } // inprogree compleated
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.closeexportBigQuryPopup()
          self.displaypopuperr()
        },
      })
    },
    resetBigQform () {
      this.exporttypeBq.forEach(function (key) {
        key.checked = ''
        // $('.exportBqCheckbox input').attr('checked', 'checked')
      })
      this.selectallbqtype = false
      this.selectedBqType = []
    },
    ShareJobClick () {
      var self = this
      var shareData = {
        user_id: this.currentuser,
        job_id: this.currentShareJob,
        users: this.shareJob,
        unique_id: this.currentShareJob_uniqueId,
      }
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerShareModel',
        data: JSON.stringify(shareData),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
          self.resetBigQform()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.displaypopuperr()
            self.closeShareModel()
          } else {
            self.$refs.shareamodel.classList.remove('active')
            jQuery('.settingPopup').removeClass('active')
            self.closeShareModel()
            self.displaypopupShared()
          }
          // self.shareJob = data.users
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.closeexportBigQuryPopup()
          self.resetBigQform()
          self.displaypopuperr()
          self.closeShareModel()
        },
      })
    },
    exportJobq (jobid, exportuser) {
      console.log(jobid, exportuser)
    },
    deleteMultiOnDemandJob () {
      var self = this
      let userchk = window.localStorage.getItem('user')
      let DeljobID = this.selectedMultiJobID
      let Deljob_UID = this.selectedMultiJob_UID
      var deleteMultiOnDemandJobData = JSON.stringify({
        user_id: userchk,
        job_ids: DeljobID,
        unique_id: Deljob_UID,
      })
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerDeleteModel',
        data: deleteMultiOnDemandJobData,
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          if (data.status === false) {
            self.downloadtriggerFailed(data.message)
            return
          }
          self.$pingpong.hideloader()
          self.$refs.jobtable.resetTable()
          self.deleteMultiModelSuccess()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        },
      })
    },
    exportMultiOnDemandJob () {
      var self = this
      let userchk = window.localStorage.getItem('user')
      let DeljobID = this.selectedMultiJobID
      let Deljob_UID = this.selectedMultiJob_UID
      var exportMultiOnDemandJobData = {
        user_id: userchk,
        job_ids: DeljobID,
        unique_id: Deljob_UID,
      }
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/ExportJobsHandler',
        data: JSON.stringify(exportMultiOnDemandJobData),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          if (data.status === false) {
            self.downloadtriggerFailed(data.message)
            return
          }
          self.$pingpong.hideloader()
          self.$refs.jobtable.resetTable()
          self.exportMultiModelSuccess()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.downloadtriggerFailed(data.message)
          // self.displaypopup()
        },
      })
    },
  },
}
</script>
<style>
*:focus,
button:focus,
button:focus-within,
button:active,
input:focus,
input:focus-within,
input:active,
a:focus,
a:focus-within,
a:active {
  outline: 0 !important;
  box-shadow: none !important;
}

th.vgt-checkbox-col {
  width: 1px !important;
  padding: 0px !important;
}
thead th.vgt-checkbox-col input[type='checkbox'] {
  position: absolute;
  top: 13px;
  left: 0px;
}
.vgt-responsive table tr.clickable.checked {
  background-color: #fff9d9;
}
.vgt-responsive table tbody th.vgt-checkbox-col input {
  display: none;
}
th.vgt-checkbox-col,
thead th.vgt-checkbox-col {
  /* background-image: url('../../../static/img/checkbox.svg'); */
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: center center;
}
thead th.vgt-checkbox-col input[type='checkbox']:after {
  content: 'Select All';
  display: inline-block;
  width: 79px;
  margin-left: 20px;
  position: absolute;
  top: -2px;
  font-size: 12px;
  font-weight: 500;
}
th.vgt-checkbox-col.checked,
.checked th.vgt-checkbox-col {
  /* background-image: url('../../../static/img/checkbox-selected.svg'); */
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: center center;
}
</style>

<style lang='scss'>
.settingPopup {
  position: absolute;
  width: 100px;
  top: -9px;
  right: -26px;
  border: 1px solid #232323;
  padding: 10px;
  background: RGBA(0, 0, 0, 0.6);
  transition: all 0.5s linear;
  height: 52px;
  z-index: 99;
  display: none;
  text-align: center;
  .closebtn {
    font-weight: 700;
    color: #fff;
    /* text-shadow: 0 1px 0 #fff; */
    position: absolute;
    top: -10px;
    right: -10px;
    display: inline-block;
    background: #000;
    border-radius: 100px;
    padding: 0px 6px;
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }
}

.settingPopup.active {
  height: 60px;
  width: 180px !important;
  display: block;
  transition: all 0.2s linear;
}
.btnbigquerrywrp {
  text-align: center;
  display: block;
}
.btnbigquerry {
  background-image: url('/static/img/bigquery.svg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
}
.btnSharemodel {
}
.td-center {
  text-align: center;
}
.good-table td,
.good-table th {
  vertical-align: middle !important;
}
.table > caption + thead > tr:first-child > td,
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > td,
.table > thead:first-child > tr:first-child > th {
  border-top: 1px solid #ddd;
}
table.table-bordered th:last-child,
table.table-bordered td:last-child {
  border-right-width: 1px;
}
table.table.table-bordered.condensed th span {
  text-transform: uppercase;
  text-indent: inherit;
  white-space: nowrap;
}
td.vue-button span:after {
  content: '\F06E';
  display: inline-block;
  width: 10px;
  height: 10px;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 20px;
  margin-left: 15px;
  position: relative;
  top: 2px;
  cursor: pointer;
}

.viewreportbutton {
  position: absolute;
  right: 0px;
  top: -4px;
  bottom: auto;
  margin: auto;
}
.hasbuttonheading span {
  display: block;
  margin-left: 50px;
}
.hideThforbutton {
  display: table-column;
  border-collapse: collapse;
}
.viewrepottbuttonwrapper {
  display: table-cell;
  padding: 0;
  margin: 0;
  vertical-align: middle;
}
th.line-numbers {
  vertical-align: middle !important;
}
.vgt-left-align {
  vertical-align: middle !important;
}
.expotbgheading {
  width: 40%;
  max-width: 300px;
  float: left;
}
.expotbgjobname {
  width: 30%;
  margin: 20px 0 20px 20px;
  font-size: 20px;
}
.sharejobid {
  width: 60%;
  margin: 20px 0 20px 20px;
  font-size: 18px;
}
.exportBqCheckbox .checkbox label {
  margin-left: 20px;
  user-select: none;
  font-size: 16px;
  line-height: 30px;
}
.exportBqCheckbox .checkbox input {
  margin-left: 20px !important;
  line-height: 30px;
  margin-top: 8px;
}
.btnexporttobigqwrapper {
  text-align: right;
  margin-right: 60px;
  margin-top: 60px;
}
.modelpopContainer.exportBigQuryPopup {
  width: 50vw;
  height: 30vw;
  min-height: 350px;
  min-width: 350px;
  position: relative;
}

.exportBqCheckbox {
  margin-top: 50px;
}
.exportBigQuryPopupWrapper,
.ShareModelPopupWrapper {
  display: none;
}
.exportBigQuryPopupWrapper.active,
.ShareModelPopupWrapper.active {
  display: block;
}
.exportBqCheckbox .error {
  margin-left: 21px;
  user-select: none;
}
</style>
<style lang="scss" scoped>
.settingsDel {
  display: none;
}
a.viewmodellink {
  font-weight: 500;
  color: #000;
  margin-bottom: 1px;
  text-decoration: underline;
  display: inline-block;
  max-width: 80%;
}
a.viewmodellink:hover,
a.viewmodellink:active,
a.viewmodellink:focus {
  font-weight: 500;
  color: #444;
  margin-bottom: 1px;
  border-bottom: none;
}
</style>
<style>
th.vgt-left-align.sorting {
  cursor: pointer;
}

th.vgt-left-align.sorting.sorting-desc::after,
th.vgt-left-align.sorting.sorting-asc::after,
.add-sorting-icon::after {
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #9fc54c;
  margin-left: 10px;
}
th.vgt-left-align.sorting.sorting-desc::after,
.add-sorting-icon::after {
  content: '\f077';
}

th.vgt-left-align.sorting.sorting-asc::after {
  content: '\f078';
}
.displayJob th.line-numbers {
  width: 86px;
  min-width: 90px;
}
</style>

<style lang="scss" scoped>
th.line-numbers {
  width: 86px;
}
.settingPopup.active .settingsBtn {
  padding: 7px 10px;
  font-size: 26px;
  margin-right: 2px;
  line-height: 27px;
}

.settingPopup.active button {
  margin: 0 4px;
}
.settingPopup.active {
  width: 125px;
  padding-top: 8px;
}
</style>
<style scoped>
i.btnbigquerry.btnbigquerry-over {
  padding: 0px;
  /* background-color: #fff; */
  /* border: none; */
  display: inline-block;
  height: 25px;
  width: 25px;
  position: relative;
  top: 2px;
}

button.deleteAllbtn {
  padding: 2px 15px;
  font-size: 21px;
  margin-right: 10px;
  border-radius: 35px;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2) !important;
}

button.btn.btn-btnbigquerry {
  padding: 7px 10px;
  margin: 0px;
  /* height: 40px; */
  border-radius: 58px;
  border: 0px solid #444;
  position: relative;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2) !important;
}

.statusLoader i {
  font-size: 24px;
}
.statusLoader .statusLoaderover {
  display: none;
}
.statusLoader {
  text-align: center;
  display: table-cell;
  padding: 0;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  transition: all 2s ease;
}
.statusLoaderover {
  transition: all 2s ease;
}
.statusLoader:hover .statusLoaderover {
  display: block;
  position: absolute;
  left: 0%;
  top: 8px;
  background-color: rgba(68, 68, 68, 0.9);
  color: #fff;
  width: 100%;
  line-height: 1.7em;
  transition: all 2s ease;
  border-radius: 5px;
}
.yellow {
  color: #e2b500;
}
.ShareModelPopupWrapper.active .checkbox {
  width: 40%;
  display: inline-block;
}
.ShareModelPopupWrapper.active .exportBqCheckbox {
  margin-top: 10px;
}

.ShareModelPopupWrapper.active .sharejobid {
  color: #9fc54c;
}
.checkbox.shareselectAll label {
  font-weight: bold;
}
.shareselectbtn {
  margin-left: 19px;
  margin-bottom: 10px;
}
.ShareModelPopupWrapper .btnexporttobigqwrapper {
  text-align: right;
  margin-right: 15px;
  margin-top: 0;
  margin-bottom: 20px;
}
</style>

<style>
th.vgt-left-align.status.sorting {
  text-align: center;
}
.vgt-selection-info-row__actions.vgt-pull-right {
  position: absolute;
  right: 0;
  top: -68px;
}

th.vgt-checkbox-col input[type='checkbox'] {
  margin: 0;
  padding: 0;
  margin-left: 6px;
}

th.vgt-checkbox-col {
  display: table-cell;
  vertical-align: middle !important;
  margin: auto !important;

  line-height: auto !important;
  text-align: center;
}

.vgt-selection-info-row {
  background: #dcdfe6 !important;
  color: #444 !important;
}

.btn-red {
  background-color: #b40000 !important;
  border: none !important;
}
.btn-red.active.focus,
.btn-red.active:focus,
.btn-red.active:hover,
.btn-red.hover,
.btn-red:active,
.btn-red:hover {
  border-color: #b40000 !important;
  background-color: #b40000 !important;
  outline: none !important;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// Displayjob.vue?64da1053